export default "__VITE_ASSET__rLIlOpH8__"